import React from 'react';
import search from '../../../../../assets/image/search-status.svg';

export default function SearchAccountsComponent({ searchText, setSearchText }) {
	return (
		<div className="accounting-search d-flex align-items-center rounded-3 shadow-sm p-2">
			<img
				src={search}
				alt="search-icon"
				width="18"
				height="18"
				className="rounded-circle me-2"
			/>
			<input
				type="text"
				placeholder="Search by account name or code"
				style={{ border: '0' }}
				autoComplete="off"
				autoFocus={true}
				value={searchText}
				data-testid="account-search-input"
				id="search-id"
				name="search"
				onChange={(e) => setSearchText(e.target.value)}
				className={`fs-4 fw-light flex-1 bg-transparent outline-none border-0 border-0 shadow-none text-gray-700 placeholder-gray-400`}
			/>
		</div>
	);
}
